import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/study',
      name: 'study',
      component: () => import(/* webpackChunkName: "study" */ './views/Study.vue')
    },
    {
      path: '/insights',
      name: 'insights',
      // route level code-splitting
      // this generates a separate chunk (insights.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "insights" */ './views/Insights.vue')
    },
  ]
})
